export default __webpack_public_path__ + "static/media/bernay15.eebab5dd.jpg";